import moment from "moment"

export const formatCustomDate = ( string, split='-' ) => {
  let newDate 
  if(string) {
    newDate = moment(string).format(`YYYY${split}MM${split}DD`)
  } else {
    newDate = moment(new Date()).format(`YYYY${split}MM${split}DD`)
    return 
  }
  return newDate
}